export default __webpack_public_path__ + "static/media/Citrix.ed119fe5.svg";